// extracted by mini-css-extract-plugin
module.exports = {"statusPage":"StatusPage_statusPage__2rnwF","text":"StatusPage_text__3VnOy"};